export default __webpack_public_path__ + "static/media/hapecon.ab140570.jpg";